import { StateParams } from '@uirouter/core';
import * as angular from 'angular';
import { AnalyticsService, ICollectedAnalyticsData } from '../../analytics.service';
import { AnalyticsBase } from '../../analyticsBase';

class ShopImpressionAnalyticsComponent extends AnalyticsBase {
    public static $inject = ['$scope', '$stateParams', '$filter', 'analyticsService', '$translate'];
    constructor(
        protected $scope: ng.IScope,
        protected $stateParams: StateParams,
        protected $filter: ng.IFilterService,
        protected analiticsService: AnalyticsService,
        protected $translate: angular.translate.ITranslateService
    ) {
        super($scope, $stateParams, $filter, analiticsService, $translate);
    }
    protected getData(id: number, filter: any): angular.IPromise<ICollectedAnalyticsData[]> {
        return this.analiticsService.getStoreImpressionAnalytics(this.id, this.filter);
    }

    protected setFilterExtension() {
        return;
    }

}

angular.module('naut').component('shopImpressionAnalytics', {
    template: require('./shopImpressionAnalytics.html'),
    controller: ShopImpressionAnalyticsComponent,
    controllerAs: 'vm',
    bindings: {

    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/analytics/components/shopImpressionAnalytics/shopImpressionAnalytics.component.ts